<template>
  <div>
    <div class="table-header th-">
      <b-row>
        <b-col md="6" class="th-col">
          <h3>Campaign report</h3>
        </b-col>
        <b-col md="6" class="th-col filter-col">
          <FilterByClientWebsite :items="items" @filterChange="updateFilter" :filterByClient="user.login_type===0"/>
        </b-col>
      </b-row>
    </div>
    <div>
      <div class="stat-section">
        <b-row>
          <b-col>
            <div class="stat-box">
              <div class="val-holder">
                <span>{{ totalLinks }}</span>
                <span v-if="dynamicsTotal" class="dynamics-ribbon">+{{ dynamicsTotal }}</span>
              </div>
              <p>Total links</p>
            </div>
          </b-col>
          <b-col>
            <div class="stat-box">
              <div class="val-holder">
                {{ avgDR }}
              </div>
              <p>Avg. Domain Rating</p>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="table-holder">
        <div class="filters-section">
          <div class="input-holder">
            <i class="icon-search"></i>
            <b-input v-model='searchText' placeholder="Search campaigns..."></b-input>
          </div>
          <div class="date-filter-holder d-flex">
            <b-input v-model='retainerFilter' placeholder="Retainer filter" class="mr-4"></b-input>
            <b-dropdown id="ddown1" no-caret :class="{'filter-selected':filterOptionName}">
              <template slot="button-content">
                <span v-if="filterOptionName">
                  <i class="icon-calendar"></i>
                  <span class="filter-name">{{ filterOptionName }}</span>
                  <i @click="clearFilter" class="icon-close"></i>
                </span>
                <span v-else>
                  <i class="icon-calendar"></i>
                  <span>Filter by date</span>
                </span>
              </template>
              <template v-for="option in filterOptions">
                <b-dropdown-item @click="filterOption=option" :key="option.id">{{ option.name }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
        </div>

        <b-table v-if="items.length"
                 :items="filteredItems"
                 :fields="fields"
                 @row-clicked="openCard"
                 responsive
        >
          <template v-slot:head()="data">
            <span v-html="formatTitle(data)"></span>
          </template>
          <template v-slot:cell(title)="data">
            <div class="value-box">
              <span class="position-relative">{{ data.value }}
                <span v-if="data.item.dynamicsDelta" class="dynamics-ribbon">+{{ data.item.dynamicsDelta }}</span>
              </span>
            </div>
          </template>
          <template v-slot:cell(retainer)="data">
            <div class="retainer-box" v-if="data.value">
              <span>{{ data.value }}</span>
            </div>
          </template>
          <template v-slot:cell(project_id)="data">
            <div class="retainer-box" v-if="data.value">
              <span>{{ data.value }}</span>
            </div>
          </template>
          <template v-slot:cell()="data">
            <div class="value-box text-right">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(report_id)="data">
            <button class="link-box" v-if="data.value || data.item.report_url" @click.stop.prevent="openReport(data.item)" target="_blank"><i
              class="icon-links"></i>View report
            </button>
          </template>
        </b-table>

      </div>

    </div>

    <campaign-card :_campaignData="campaignData"
                   ref="campaignCard"
                   @done="campaignsInit"
    ></campaign-card>
  </div>
</template>

<script>
import moment from 'moment';
import helpers from '../_mixins/helpers';
import axios from '../_helpers/axios';
import {apiUrl} from 'config';

export default {
  name: 'PastCampaignsTable',
  components: {
    'campaign-card': () => import('@/components/CampaignCard.vue'),
    'FilterByClientWebsite': () => import('@/components/FilterByClientWebsite.vue'),
  },
  mixins: [helpers],
  data: () => ({
    searchText: '',
    retainerFilter: '',
    selected_client_id: null,
    selected_website: '',
    campaignData: null,
    fields: [
      {
        key: 'client_name',
        label: 'Client',
        variant: 'client'
      },
      {
        key: 'website',
        label: 'Website',
        class: 'w-10'
      },
      {
        key: 'title',
        label: 'Project title',
        variant: 'title',
        formatter: (value, field, item) => {
          if (item.report_title) {
            return item.report_title;
          }
          return value;
        }
      },
      {
        key: 'retainer',
        variant: 'retainer',
        label: 'Retainer'
      },
      {
        key: 'project_id',
        variant: 'project_id',
        label: 'Project'
      },
      {
        key: 'links_count',
        variant: 'links_count',
        label: 'Links',
        sortable: true,
        formatter: (value, key, item) => {
          if (!item.report_id && item?.links_num) {
            return item?.links_num
          }
          return value
        }
      },
      {
        key: 'avg_dr',
        variant: 'avg_dr',
        label: 'Avg. \nAhrefs&nbsp;DR',
        sortable: true,
        formatter: (value, key, item) => {
          if (!item.report_id && item?.manual_avg_dr) {
            return item?.manual_avg_dr
          }
          try {
            return Math.round(value);
          } catch (e) {
            return value;
          }
        }
      },
      {
        key: 'report_id',
        variant: 'report_id',
        label: 'Report',
      },
    ],
    filterOptions: [
      {
        id: 0,
        name: 'last 3 months',
        val: moment().subtract(3, 'months').format('YYYY-MM-DD')
      },
      {
        id: 1,
        name: 'last 6 months',
        val: moment().subtract(6, 'months').format('YYYY-MM-DD')
      },
      {
        id: 2,
        name: 'last year',
        val: moment().subtract(12, 'months').format('YYYY-MM-DD')
      },
      {
        id: 3,
        name: 'last 5 years',
        val: moment().subtract(5, 'years').format('YYYY-MM-DD')
      },
    ],
    filterOption: -1,
    Deselect: {
      render: createElement => {
        const el = createElement('i', {
          attrs: {
            class: 'icon-close'
          }
        });
        return el;
      },
    },

  }),
  mounted: function () {
    if (this.user.login_type === 1) {
      this.fields = this.fields.filter(e => e.key !== 'client_name');
    }
    this.$nextTick(() => {
      this.campaignsInit();
    });
  },
  methods: {
    formatTitle(data) {
      return data.label.replace('\n', '<br>');
    },
    async openReport(item) {
      if (!item.report_id && item.report_url) {
        return window.open(item.report_url, '_blank');
      }
      await axios.post(`${apiUrl}/api/reporting/resetDynamics`, {report_id: item.report_id})
        .then(() => {
          this.$store.commit('campaigns/addDynamicsMarked', item.report_id);
          window.open(`https://linkbox.neomam.com/view/${item.report_ref}`, '_blank');
        });
    },
    clearFilter() {
      this.filterOption = -1;
    },
    updateFilter(clientId, website) {
      this.selected_client_id = clientId
      this.selected_website = website
    },
    formatMonth(month) {
      return moment(`${month}-01`).format('MMMM YYYY');
    },
    openCard(item) {
      if (this.user.login_type !== 0) {
        return;
      }
      this.campaignData = item;
      this.$refs.campaignCard.show();
    },
    campaignsInit() {
      this.$store.dispatch('campaigns/getAll');
      this.$store.dispatch('campaigns/getPast');
    },
    monthItems(month) {
      let allItems = this.items.filter(e => {
        let projMonth = moment(e.project_start).format('YYYY-MM');
        return projMonth === month;
      });

      // debugger
      return allItems;
    }
  },
  computed: {
    filteredSites() {
      let allItems = (this.allSites && this.allSites.length) ? this.allSites : [];
      if (this.selected_client_id) {
        allItems = allItems.filter(i => i.client_id === this.selected_client_id)
      }
      return allItems;
    },
    allSites() {
      let allItems = this.items || [];
      if (!allItems.length) return [];

      allItems = allItems.reduce((acc, e) => {
        if (!acc.find(ae => ae.id === e.website_id)) acc.push({
          id: e.website_id,
          name: e.website,
          client_id: e.client_id
        });
        return acc;
      }, []);

      allItems = allItems.sort((a, b) => {
        return a.name > b.name ? -1 : 1;
      });

      return allItems;
    },
    allClients() {
      let allItems = this.$store.state.refs.clients_active || [];
      return allItems.length ? allItems : [];
    },
    dynamicsItems() {
      let allItems = this.$store.state.campaigns.dynamics || [];
      if (!allItems.length) {
        return [];
      }
      let markedItems = this.$store.state.campaigns.dynamicsMarked || [];

      allItems = allItems.map(e => {
        e.marked = markedItems.indexOf(e.report_id) >= 0;
        return e;
      });

      return allItems;
    },
    dynamicsTotal() {
      return this.filteredItems.reduce((acc, e) => {
        acc += e.dynamicsDelta ? e.dynamicsDelta : 0;
        return acc;
      }, 0);
    },
    items() {
      let allItems = this.$store.state.campaigns.past || [];
      allItems = Array.isArray(allItems) ? allItems : [];
      allItems = allItems.filter(e => {
        if (this.filterOption !== -1) {
          if (e.project_end < this.filterOptionValue) {
            return false;
          }
        }

        if (this.searchText) {
          if (e.title.toLowerCase().indexOf(this.searchText.toLowerCase()) < 0) {
            return false;
          }
        }

        if (this.retainerFilter) {
          if (e.retainer.toLowerCase().indexOf(this.retainerFilter.toLowerCase()) < 0) {
            return false;
          }
        }

        if (this.selected_client_id) {
          if (e.client_id !== this.selected_client_id) {
            return false;
          }
        }

        return true;
      });

      allItems = allItems.sort((a, b) => {
        if (a.report_sent && b.report_sent) {
          return a.report_sent > b.report_sent ? -1 : 1;
        } else if (a.report_sent) {
          return -1;
        } else if (b.report_sent) {
          return 1;
        }

        if (a.project_end && b.project_end) {
          return a.project_end > b.project_end ? -1 : 1;
        }
      });

      let di = this.dynamicsItems;
      if (di.length) {
        allItems = allItems.map(e => {
          e.dynamicsDelta = 0;
          let found = di.find(de => de.report_id === e.report_id);
          if (found && !found.marked) {
            e.dynamicsDelta = found.delta;
          }
          return e;
        });
      }
      ;

      return allItems;
    },
    filteredItems() {
      let allItems = this.items || [];
      if (!allItems.length) return allItems;

      if (this.selected_website) {
        allItems = allItems.filter(i => i.website_id === this.selected_website.id);
      }

      return allItems;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    totalLinks() {
      if (this.filteredItems.length) {
        let res = this.filteredItems.reduce((acc, el) => {
          const int = (!el.report_id && el?.links_num) || parseInt(el.links_count);
          acc += isNaN(int) ? 0 : int;
          return acc;
        }, 0);
        return this.kFormatter(res);
      }
      return 0;
    },
    avgDR() {
      if (this.filteredItems.length) {
        let res = this.filteredItems.reduce((acc, el) => {
          const int = (!el.report_id && el?.manual_avg_dr) || parseInt(el.avg_dr);
          acc += isNaN(int) ? 0 : int;
          return acc;
        }, 0);
        return Math.round(res / this.filteredItems.length, 0);
      }

      return 0;
    },
    filterOptionName() {
      if (this.filterOption !== -1) return this.filterOption.name;
      return '';
    },
    filterOptionValue() {
      if (this.filterOption !== -1) return this.filterOption.val;
      return '';
    },
  },

};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';

.dynamics-ribbon {
  background: $green;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  font-weight: 500;
  border-radius: 10px;
  padding: 2px 5px 3px;
  margin-left: 8px;
  position: absolute;
  left: 100%;
}

.stat-section {
  margin-bottom: 30px;
  @include sm {
    flex-wrap: wrap;
    box-shadow: 0 0 10px 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
  @include xs {
    > .row {
      margin-left: -10px;
      margin-right: -10px;

      > .col {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }

  .col {
    @include sm {
      flex-basis: 100%;
      position: relative;
      &:not(:last-child) {
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: block;
          background: $lgrey3;
          width: 90%;
          height: 1px;
          opacity: .5;
          margin: auto;
        }
      }
    }
  }

  .stat-box {
    background: #fff;
    box-shadow: 0 0 10px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 6px;
    @include sm {
      box-shadow: none;
    }

    p {
      color: $lgrey;
    }
  }

  .val-holder {
    font-weight: 600;
    font-size: 26px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    position: relative;
  }
}

.table-holder {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 0 10px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.filters-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @include xs {
    flex-direction: column;
  }

  .input-holder {
    position: relative;
    width: 524px;
    max-width: 100%;

    input {
      padding-left: 45px;
    }

    i {
      font-size: 18px;
      color: $lgrey;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 15px;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
    }
  }

  .site-filter-holder {
    display: flex;
    align-items: center;

    label {
      line-height: 0;
      margin: 0 10px 0 0;
    }

    .site-box {
      width: 15rem;
    }
  }

  .date-filter-holder {
    color: $text-muted;
    @include md {
      margin-left: 15px;
    }
    @include xs {
      margin-left: 0;
      margin-top: 15px;
    }

    .b-dropdown {
      &.filter-selected {
        pointer-events: none;

        .icon-close {
          pointer-events: auto;
        }
      }
    }

    .filter-name {
      margin-right: 10px;
    }

    i {
      margin-right: 10px;
      color: $lgrey;
      font-size: 16px;

      &.icon-close {
        font-size: 12px;
        color: $dark;
        cursor: pointer;
      }
    }

    /deep/ button {
      background: $lgrey2;
      color: inherit;
      padding: 10px;
      font-weight: 400;

      &:active {
        background: $lgrey2;
        color: inherit;
      }
    }
  }
}

/deep/ .table.b-table {
  .table-client {
    @include xs {
      width: 100px;
      max-width: 100px;
      .value-box {
        word-wrap: break-word;
      }
    }
  }

  .table-title {
    @include xs {
      width: 200px;
      min-width: 200px;
    }
  }

  > thead > tr {
    > th {
      vertical-align: middle;
      padding: 10px 30px 10px 0;

      &[aria-sort]:not(.b-table-sort-icon-left) {
        padding: 10px 30px 10px 0;
        background-position: right 15px center;
      }

      text-transform: uppercase;
      text-align: center;
      color: $lgrey;
      font-weight: 500;
      line-height: 1;
    }
  }

  td {
    padding: 10px 15px 10px 0;
    vertical-align: middle;
  }

  th, td {
    border: none;
  }

  tr {
    border-bottom: 1px solid $lgrey6;
  }

  tbody {
    tr {
      cursor: pointer;
    }
  }

  .value-box {
    padding-right: 15px;
  }

  .link-box {
    border: none;
    width: 100%;
    color: $red;
    white-space: nowrap;
    display: flex;
    align-items: center;

    i {
      margin-right: 10px;
      color: $lgrey;
    }
  }

  .retainer-box, .link-box {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $lgrey4;
    margin: 10px 0;
    padding: 8px 12px;
    border-radius: 4px;
  }

  .link-box {
    background: $antique;
  }
}

</style>
